'use strict';

exports.__esModule = true;
exports.page = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pageActions = require('../actions/page-actions');

var _reduxSimpleAuth = require('redux-simple-auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	error: false,
	submitAttempted: false
};

var page = exports.page = function page(state, action) {
	switch (action.type) {
		case _pageActions.UPDATE_EMAIL:
			return (0, _assign2.default)({}, state, {
				email: action.email
			});
		case _pageActions.UPDATE_PASSWORD:
			return (0, _assign2.default)({}, state, {
				password: action.password
			});
		case _pageActions.REMEMBER_ME_TOGGLE:
			return (0, _assign2.default)({}, state, {
				rememberMeChecked: !action.rememberMeChecked
			});
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_FAILED:
			{
				var errorMessage = action && action.payload && action.payload.response && action.payload.response.data;
				var msg = errorMessage && errorMessage === 'null value in column "email" violates not-null constraint' ? 'Please enter your details' : action.payload.response.data;
				return (0, _assign2.default)({}, state, {
					error: true,
					errorMessage: msg || 'There is an error with our servers. Please try again later.',
					submitAttempted: true
				});
			}
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_SUCCEEDED:
			return (0, _assign2.default)({}, state, {
				error: false
			});
		case _pageActions.SET_VALID_EMAIL:
			return (0, _assign2.default)({}, state, {
				validEmail: action.valid
			});
		case _pageActions.LOGIN_VALIDATION_FAILED:
			return (0, _assign2.default)({}, state, {
				submitAttempted: true,
				submitFailed: true
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/login-page/lib/reducers/page-reducers.js